import React, { useEffect, useState } from 'react';
import { MessageCircleIcon } from 'lucide-react';
import { loadPublicSettings } from '../data/repository';
export function WhatsAppButton() {
  const [phone, setPhone] = useState('385992796250');
  useEffect(() => {
    void loadPublicSettings().then(settings => {
      const local = settings.contactInfo.phone.replace(/\D/g, '');
      if (local) setPhone(local.startsWith('0') ? `385${local.slice(1)}` : local);
    }).catch(() => undefined);
  }, []);
  return <a href={`https://wa.me/${phone}`} target="_blank" rel="noreferrer" aria-label="Pošalji WhatsApp poruku" className="fixed bottom-20 right-6 z-50 inline-flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg hover:bg-[#1ebe5d] md:bottom-8" data-id="element-176" data-mp="19giu9tkgmo01">
      <MessageCircleIcon size={28} data-id="element-177" data-mp="2zqbzq3ylx6vk" />
    </a>;
}